import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import './styles.scss';

type dataArrType = {
  value: string;
  label: string;
  isVisible: boolean;
};

type ReportFilterMultiSelectType = {
  titleFilter: string;
  dataArr: dataArrType[];
  selected: string[];
  setSelected: (value: string[]) => void;
  disabled?: boolean;
  disableBorder?: boolean;
  className?: string;
  // Opt-in — off by default, unaffected everywhere except a caller that
  // explicitly wants a flatter look without MUI's default ripple/hover tint
  // (Portfolio Performance's Transactions filter chips).
  disableButtonRipple?: boolean;
};

export const ReportFilterMultiSelect = ({
  titleFilter,
  dataArr,
  selected,
  setSelected,
  disabled = false,
  disableBorder,
  className,
  disableButtonRipple = false,
}: ReportFilterMultiSelectType) => {
  const handleSelect = (value: string) => {
    if (disabled) return;

    if (selected.includes(value)) {
      setSelected(selected.filter((item) => item !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  const classNames = `report-buttons-multi-select-options ${disableBorder ? 'no-border' : ''} ${className || ''}`;

  return (
    <div className={classNames}>
      <span className="report-buttons-label">{titleFilter}</span>
      {dataArr?.map((item) => {
        if (!item.isVisible) return null;

        return (
          <div key={item.value} className="report-buttons-options-list">
            <Button
              key={item.value}
              className={`range-btn ${selected.includes(item.value) ? 'selected-range' : ''}`}
              onClick={() => handleSelect(item.value)}
              disableRipple={disableButtonRipple}
            >
              {selected.includes(item.value) && <FontAwesomeIcon icon={faCheck} />}
              {item.label}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
